import { request } from "../../utils/config"
import { getRate_mainUSDvsUZS } from "./types/getRate"
export const GET_CURRENCY_RATE = async (): Promise<getRate_mainUSDvsUZS> => {
  const response = await request({
    url: "Helpers/GetMainUSDvsUZS",
  })
  return response.data
}
